module.exports = __webpack_public_path__ + "media/images/svg/logo_diputacio-ef78b8c3b9884c0c8b974c21b520db48.svg";